import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=55961624&"
import script from "./ranking.vue?vue&type=script&lang=ts&"
export * from "./ranking.vue?vue&type=script&lang=ts&"
import style0 from "./ranking.vue?vue&type=style&index=0&id=55961624&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports